<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Delete selected company code?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected company code.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn color="accent" flat @click="deleteCompanyById()" :loading="getLoading" :disable="getLoading">
                delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Details</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <v-card-title>
            <v-btn dark color="accent" to="/company/new">new company</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :loading="getLoading"
            v-bind:headers="headers"
            v-bind:items="getAllCompanies"
            v-bind:search="search"
            v-model="selected"
            item-key="id"
            class="elevation-1">
            <template slot="headerCell" slot-scope="props">
            <span>
              {{ props.header.text }}
            </span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <v-btn flat icon @click="editCompanyById(props.item.id)" color="accent lighten-1" slot="activator">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Change</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{ props.item.company_code}}</td>
              <td class="text-xs-left">{{ props.item.description}}</td>
              
            </template>
          </v-data-table>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'company-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      dialogForm: false,
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Company Code',
          align: 'left',
          value: 'company_code'
        },
        {
          text: 'Description',
          align: 'left',
          value: 'description'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions(['fetchAllCompanies']),

    editCompanyById: function (id) {
      this.$router.push({ name: 'changeCompany', params: { id: id } })
    },

    toggleDialog: function (id) {
      this.selectedId = id
      this.dialog = true
    },

    deleteCompanyById: function () {
      // this.deleteApprovalProfile(this.selectedId).then(() => {
      //   this.dialog = false
      //   let response = this.getResponse
      //   this.snackbar = true
      //   this.text = (response.status === 200) ? 'Deleted successfully.' : response.data.message
      //   this.color = (response.status === 200) ? 'success' : 'error'
      // })
    },

    loadCompanies: function () {
      this.fetchAllCompanies()
        .then(() => {
          //  do nothing
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted: function () {
    this.loadCompanies()
  },
  computed: {
    ...mapGetters(['getLoading', 'getResponse', 'getAllCompanies'])
  }
}
</script>

<style scoped>
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/company/CompanyDetail.vue